import FormattedMessage from 'I18n/components/FormattedMessage';
import { useChecklistEstimation } from '../../../hooks/task';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const ChecklistDuration = ({
  estimation
}) => {
  const contextualEstimation = useChecklistEstimation();
  const {
    remainingDuration,
    tasksCompleted,
    totalTasks
  } = estimation || contextualEstimation;
  if (remainingDuration === 0 || tasksCompleted === totalTasks) {
    return null;
  }
  return /*#__PURE__*/_jsx(Text, {
    color: "text-core-subtle",
    "data-test-id": "helptext-checklist-duration",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.completionTimeEstimate",
      options: {
        count: remainingDuration,
        tasksCompleted,
        totalTasks
      }
    })
  });
};
export default ChecklistDuration;